<template>
  <div>
    <import-page
      title="批量导入申报订单"
      :loading="loading"
      :templateUrl="templateUrl"
      :columns="columns"
      :isValid="isValid"
      :limit="1000"
      :previewList="previewList"
      :importLoading="importLoading"
      @on-import="importList"
      @on-preview="previewFile"
    >
    </import-page>
  </div>
</template>

<script>
import ImportPage from "@/components/import-page";
import declareApi from "@/api/declare";
import { CONST_IMPORT_ORDER_TEMPLATE_URL } from "@/config/constant";
export default {
  data() {
    return {
      columns: [
        {
          title: "商户订单号",
          key: "merchantOrderNo",
          align: "center",
          minWidth: 120,
        },
        {
          title: "渠道编号",
          key: "merchantName",
          align: "center",
          minWidth: 120,
        },
        {
          title: "电商企业编号",
          key: "enterpriseCompanyCode",
          align: "center",
          minWidth: 120,
        },
        { title: "支付方式", key: "payType", align: "center", minWidth: 120 },
        {
          title: "物流方式",
          key: "carrierCode",
          align: "center",
          minWidth: 120,
        },
        {
          title: "订购人姓名",
          key: "payerName",
          align: "center",
          minWidth: 120,
        },
        {
          title: "订购人身份证",
          key: "payerIdCard",
          align: "center",
          minWidth: 120,
        },
        {
          title: "收货人姓名",
          key: "consigneeName",
          align: "center",
          minWidth: 120,
        },
        {
          title: "收货人电话",
          key: "consigneePhoneNum",
          align: "center",
          minWidth: 120,
        },
        {
          title: "收货地址",
          key: "",
          align: "center",
          minWidth: 200,
          render: (h, params) => {
            const { province, city, region, address } = params.row;
            return (
              <div>
                {province}
                {city}
                {region}
                {address}
              </div>
            );
          },
        },
        {
          title: "总运费",
          key: "shippingFee",
          align: "center",
          minWidth: 120,
        },
        {
          title: "订单总金额",
          key: "totalPrice",
          align: "center",
          minWidth: 120,
        },
        {
          title: "总优惠金额",
          key: "discountPrice",
          align: "center",
          minWidth: 120,
        },
        {
          title: "总实付金额",
          key: "paymentPrice",
          align: "center",
          minWidth: 120,
        },
        {
          title: "货主编号",
          key: "storeCode",
          align: "center",
          minWidth: 200,
        },
        {
          title: "商品编号",
          key: "thirdSkuId",
          align: "center",
          minWidth: 200,
        },
        { title: "商品数量", key: "quantity", align: "center", minWidth: 120 },
        {
          title: "商品单价",
          key: "skuUnitPrice",
          align: "center",
          minWidth: 120,
        },
        {
          title: "校验信息",
          key: "errorMsg",
          align: "center",
          fixed: "right",
          render: (h, params) => {
            const msg = params.row.errorMsg;
            return (
              <div>
                <el-tag type="success" v-show={!msg}>
                  校验成功
                </el-tag>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content={msg}
                  placement="top"
                  v-show={msg}
                >
                  <el-tag type="danger">校验失败</el-tag>
                </el-tooltip>
              </div>
            );
          },
        },
      ],
      loading: false,
      templateUrl: CONST_IMPORT_ORDER_TEMPLATE_URL,
      isValid: false,
      previewList: [],
      importLoading: false,
    };
  },
  components: {
    ImportPage,
  },
  methods: {
    previewFile(fileUrl) {
      this.loading = true;
      if (!fileUrl) {
        this.$message({
          message: "上传文件失败，请稍候重试",
          type: "error",
        });
        return;
      }
      if (!/.(xls|xlsx)$/.test(fileUrl)) {
        this.$message({
          message: "您上传的文件格式不正确",
          type: "error",
        });
        return;
      }
      declareApi
        .previewDeclareOrderImport({
          fileUrl: fileUrl,
        })
        .then((res) => {
          console.log(res);
          this.previewList = res.customsDeclareOrderImportInfoList;
          const result = [];
          this.previewList.map((item) => {
            if (item.errorMsg) {
              result.push(item);
            }
          });

          // 判断是否可以导入
          if (result.length > 0) {
            this.isValid = false;
          } else {
            this.isValid = true;
          }
          this.loading = false;
        });
    },
    importList() {
      this.importLoading = true;
      declareApi
        .batchImportDeclareOrder({
          request: JSON.stringify(this.previewList),
        })
        .then((res) => {
          this.importLoading = false;
          if (res.value) {
            this.$message.success("导入成功");
            this.$router.back(-1);
          } else {
            this.$message.error("导入失败");
          }
        })
        .finally(() => {
          this.importLoading = false;
        });
    },
  },
};
</script>
